import { Directive, inject, ViewContainerRef } from '@angular/core';
import { ModalService } from '../../services/modal.service';

@Directive({
  selector: '[appModalContainer]'
})
export class ModalContainerDirective {
  private readonly _viewContainerRef = inject(ViewContainerRef);
  private readonly _modalService = inject(ModalService);

  constructor() {
    // Register the container with the ModalService.
    this._modalService.registerContainer(this._viewContainerRef);
  }
}
